import React, { FC } from 'react';
import MuiInputLabel, { InputLabelProps as MuiInputLabelProps } from '@mui/material/InputLabel';
import { BpDesignSystem } from '../../types';
import { Tooltip, TooltipProps } from '../Tooltip';
import { Icon, IconProps } from '../Icon';
import { styled } from '../../styles';

export type LabelWithIconProps = BpDesignSystem.PropsWithChildren<
  MuiInputLabelProps & {
    dataTest?: string;
    slotProps: {
      tooltipProps: Omit<TooltipProps, 'children'>;
      iconProps?: Partial<IconProps>;
    };
  }
>;

export const LabelWithIcon: FC<LabelWithIconProps> = ({
  children,
  dataTest,
  slotProps = {
    tooltipProps: {},
    iconProps: {}
  },
  ...inputLabelProps
}) => (
  <StyledLabelWithIcon data-test={dataTest}>
    <MuiInputLabel {...inputLabelProps}>{children}</MuiInputLabel>
    <StyledTooltip>
      <Tooltip placement="top" {...slotProps.tooltipProps}>
        <Icon name="info" size={18} {...slotProps.iconProps} />
      </Tooltip>
    </StyledTooltip>
  </StyledLabelWithIcon>
);

const StyledLabelWithIcon = styled('div')`
  align-items: center;
  display: inline-flex;
`;

const StyledTooltip = styled('div')`
  margin-left: 0.25rem;
  position: relative;
  top: -1px;
`;
